<template>
  <b-modal
    ref="modalRef"
    dialog-class="!max-w-[600px]"
    body-class="!p-[32px] text-black w-full text-center"
    size="lg"
    centered
    hide-footer
    hide-header
    hide-header-close
    no-close-on-esc
  >
    <img
      src="https://storage.googleapis.com/komerce/assets/svg/Icon-Warning.svg"
      alt="Warning"
      class="mx-auto mb-[16px]"
    >
    <b-button
      variant="ghost"
      class="absolute top-[10px] right-[1px] !text-[32px] text-[#292D32] rotate-45"
      @click="handleCancel"
    >
      <span class="k-add" />
    </b-button>
    <h4 class="mb-[16px] text-[24px] font-semibold text-[#333333]">
      {{ text.title }}
    </h4>
    <p class="mb-[18px] text-[#626262]">
      {{ text.description }}
    </p>
    <div class="flex justify-center items-center gap-[12px]">
      <b-button
        variant="outline-primary"
        class="w-full"
        :disabled="loading"
        @click="handleCancel"
      >
        {{ text.cancel }}
      </b-button>
      <b-button
        variant="primary"
        class="w-full !flex items-center justify-center gap-[8px]"
        :disabled="loading"
        @click="submitModal"
      >
        <b-spinner
          v-if="loading"
          small
        />
        {{ text.accept }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'Modal',
  data() {
    return {
      loading: false,
      text: {
        title: '',
        description: '',
        cancel: '',
        accept: '',
      },
    }
  },
  created() {
    this.callback = null
    this.cancelFn = null
  },
  methods: {
    /**
     * Tampilkan modal konfirmasi dan simpan callback upgrade status
     * @param {{ callback: () => Promise<unknown>, onCancel: () => void }} options
     */
    showModal({
      callback, onCancel, title, description, cancelText, acceptText,
    }) {
      this.text = {
        title,
        description,
        cancel: cancelText || 'Batalkan',
        accept: acceptText || 'Ya, lanjutkan',
      }
      this.callback = callback
      this.cancelFn = onCancel
      this.$refs.modalRef.show()
    },
    /** Tutup modal dan hapus callback terdaftar */
    closeModal() {
      this.text = {
        title: '',
        description: '',
        cancel: '',
        accept: '',
      }
      this.callback = null
      this.cancelFn = null
      this.loading = false
      this.$refs.modalRef.hide()
    },
    handleCancel() {
      this.cancelFn()
      this.closeModal()
    },
    /** Jalankan callback upgrade status setelah user konfirmasi */
    async submitModal() {
      this.loading = true
      try {
        await this.callback()
        this.closeModal()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
